import React from 'react';

const MedicalBagIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(6.000000, 7.000000)'>
        <path d='M8.01383706,0 L6.01383706,2 L6.01383706,4 L3.01383706,4 C1.86383706,4 1.13383706,5 1.01383706,6 L0.013837064,16 C-0.106162936,17 0.553837064,18 2.01383706,18 L18.0138371,18 C19.4738371,18 20.1338371,17 20.0138371,16 L19.0138371,6 C18.8938371,5 18.0738371,4 17.0138371,4 L14.0138371,4 L14.0138371,2 L12.0138371,0 L8.01383706,0 M8.01383706,2 L12.0138371,2 L12.0138371,4 L8.01383706,4 L8.01383706,2 M9.01383706,7 L11.0138371,7 L11.0138371,10 L14.0138371,10 L14.0138371,12 L11.0138371,12 L11.0138371,15 L9.01383706,15 L9.01383706,12 L6.01383706,12 L6.01383706,10 L9.01383706,10 L9.01383706,7 Z' />
      </g>
    </g>
  </svg>
);

export default MedicalBagIcon;
